import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, SubmitInput, Error, Success } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';

const TestDiversifiedNotifications: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [date, setDate] = useState('');

  const handleChange = (event: any) => {
    setDate(event.target.value);
  };
  const handleClick = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    if (!date) {
      alert('Please select a date');
      return;
    }

    setIsLoading(true);

    try {
      const selectedDate = new Date(date);
      await callFunction('websiteInternalFunctions/notificationTrigger', {
        timeMock: selectedDate
      });
      setSuccess('Notification trigger executed successfully');
    } catch (error: any) {
      console.error('Failed to trigger notifications:', error);
      setError(error?.message || error?.error || 'Failed to trigger notifications');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleClick}>
      <h2>To use this feature make sure that:</h2>
      <ul>
        <li>
          You just created a fresh new user that has admin privileges and signed to this portal with
          that user.
        </li>
        <li>You have signed in with this user on the internal app on your phone.</li>
        <li>Started a practical guide.</li>
      </ul>
      <input type="date" value={date} onChange={handleChange} />
      <p>Selected Date: {date}</p>
      <SubmitInput type="submit" value={isLoading ? "Triggering..." : "Trigger Notifications"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
      </Form>
    </>
  );
};

export { TestDiversifiedNotifications };
